/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Types_RoomInputs */

const en_admin_resources_resource_types_room = /** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room`)
};

const de_admin_resources_resource_types_room = /** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raum`)
};

const es_admin_resources_resource_types_room = /** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala`)
};

const fr_admin_resources_resource_types_room = /** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chambre`)
};

/** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */
const it_admin_resources_resource_types_room = en_admin_resources_resource_types_room;

/** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_types_room = en_admin_resources_resource_types_room;

/** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */
const pl_admin_resources_resource_types_room = en_admin_resources_resource_types_room;

/** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */
const hu_admin_resources_resource_types_room = en_admin_resources_resource_types_room;

/** @type {(inputs: Admin_Resources_Resource_Types_RoomInputs) => LocalizedString} */
const ro_admin_resources_resource_types_room = en_admin_resources_resource_types_room;

/**
* | output |
* | --- |
* | "Room" |
*
* @param {Admin_Resources_Resource_Types_RoomInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_types_room = /** @type {((inputs?: Admin_Resources_Resource_Types_RoomInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Types_RoomInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_types_room(inputs)
	if (locale === "de") return de_admin_resources_resource_types_room(inputs)
	if (locale === "es") return es_admin_resources_resource_types_room(inputs)
	if (locale === "fr") return fr_admin_resources_resource_types_room(inputs)
	if (locale === "it") return it_admin_resources_resource_types_room(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_types_room(inputs)
	if (locale === "pl") return pl_admin_resources_resource_types_room(inputs)
	if (locale === "hu") return hu_admin_resources_resource_types_room(inputs)
	return ro_admin_resources_resource_types_room(inputs)
});
export { admin_resources_resource_types_room as "admin.resources.resource_types.room" }